import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * 評価項目ごとに確定した目標・達成基準の参照表示。
 *
 * 目標は評価項目ごとに設定されるため、画面上部に単一の目標をまとめて出すのではなく
 * 各項目の入力欄の近くに、その項目の目標を表示する。
 * 設計: 設計書類/02_評価管理機能/目標設定の項目別化と個人別重み設計.md §3.8
 */
/**
 * 項目別の目標が1件でも入っているか。
 * 目標参照パネルを承認状態のみの表示に切り替えるかの判定に使う。
 * 1件も無い場合はパネル側で従来の単一目標表示へフォールバックさせる。
 */
export function hasAnyItemGoal(
  items: { target_description?: string | null; achievement_criteria?: string | null }[]
): boolean {
  return items.some(
    (item) =>
      (item.target_description?.trim() ?? '') !== '' ||
      (item.achievement_criteria?.trim() ?? '') !== ''
  );
}

interface ItemGoalReferenceProps {
  targetDescription?: string | null;
  achievementCriteria?: string | null;
  title?: string;
}

export const ItemGoalReference: React.FC<ItemGoalReferenceProps> = ({
  targetDescription,
  achievementCriteria,
  title = 'この項目の目標',
}) => {
  const hasTarget = (targetDescription?.trim() ?? '') !== '';
  const hasCriteria = (achievementCriteria?.trim() ?? '') !== '';

  if (!hasTarget && !hasCriteria) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        borderRadius: 1,
        bgcolor: 'grey.100',
        borderLeft: 3,
        borderColor: 'success.main',
      }}
    >
      <Typography variant="caption" fontWeight="bold" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: hasCriteria ? 1.5 : 0 }}>
        {targetDescription || '（未入力）'}
      </Typography>
      {hasCriteria && (
        <>
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            達成基準
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {achievementCriteria}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default ItemGoalReference;
